const routes = [
  {
        path: '/agendamentos/:catchAll(.*)',
        component: {
            created() {
                window.location.replace('/agenda/agendamentos/' + this.$route.params.catchAll)
            },
            render: h => h('div') 
        }
    },
    {
        path: '/agendamentos',
        component: {
            created() {
                window.location.replace('/agenda/agendamentos')
            },
            render: h => h('div')
        }
    }
]

export default routes